<template>
  <!-- HTML 정의하는 부분 -->
  <!-- 1차 퍼블리셔가 작업 영역 -->
  <!-- 2차 개발자가 Template 화 작업 진행-->
  <v-card class="mb-2">
    <v-card-title class="title--dark py-2" @click="clickTitle" style="cursor:Pointer;">
      <span class="white--text text-truncate" style="max-width: 320px">{{ info.title }}</span>
      <v-spacer></v-spacer>
      <div v-if="showStatus.show" style="width: 38px;height: 28px">
        <v-img :src="showStatus.icon" height="28" width="36"></v-img>
      </div>
    </v-card-title>
    <v-card-text class="pa-0">
      <v-container fluid>
        <v-row>
          <v-col class="pb-0" cols="6">
            <gauge-chart :flag="refreshFlag" color="#90F072"  title="발전량" :max="info.pvpcsPacMax" :value="info.pvpcsPac" unit="KW"></gauge-chart>
          </v-col>
          <v-col class="pb-0" cols="6">
            <gauge-chart :flag="refreshFlag" title="당일 발전량" :max="info.pvpcsDailyPMax" :value="info.pvpcsDailyP" unit="KWH"></gauge-chart>
          </v-col>
          <v-col cols="12" class="text-center py-0">
            <span class="site-card-time">{{info.dailytime}}</span>
            hr
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-expand-transition>
      <v-card style="background-color:#303B56" class="ma-2" v-show="show">
        <v-simple-table
          fixed-header
          height="150px"
          dense
        >
          <template v-slot:default>
            <thead>
            <tr>
              <th class="text-center">
              </th>
              <th class="text-center">
                상태
              </th>
              <th class="text-center">
                발전량
              </th>
              <th class="text-center">
                당일
                <p>발전량</p>
              </th>
            </tr>
            </thead>
            <tbody>
            <tr
              v-for="item in inverters"
              :key="item.site+item.station"
            >
              <td class="text-center">{{ item.subcomp }}</td>
              <td class="text-center">
                <v-chip
                  label
                  small
                  outlined
                  class="px-1"
                  :style="getInverterStatusImage(item.run_status)"
                >
                  <div
                    style="width: 30px;"
                  >{{ item.run_status === 'Run' ? '가동' : item.run_status === 'Pause' ? '이상': '고장' }}</div>
                </v-chip>
              <td class="text-center">{{ item.PVPCS_Pac }}</td>
              <td class="text-center">{{ item.PVPCS_Daily_P }}</td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>
    </v-expand-transition>
    <v-card-actions class="title--dark pa-0">
      <v-spacer></v-spacer>
      <v-btn
        icon
        @click="openDrawer"
      >
        <v-icon>{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>
</template>

<script>
// 스크립트를 정의하는 부분
// 개발자 작업 영역
import GaugeChart from '@/components/monitoring/GaugeChart'
import { getMonitoringSiteInverter } from '@/api/monitoring/monitoring'
// [ECMA6] export default 된 부분이 외부에서 import로 사용할 수 있게 된다.
export default {
  // .vue 내부에서 사용되는 model
  // model 기반으로 vue는 동작된다.
  name: 'SiteCard',
  components: {
    GaugeChart
  },
  props: {
    site: {
      type: Object
    },
    refresh: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      refreshFlag: 0,
      show: false,
      inverters: [],
      inverterStatus: {
        Run: 'color: #90F072;border-color:#90F072;background-color: rgba(170,251,159,0.5) !important;',
        Pause: 'color: #FFA837;border-color:#FFA837;background-color: rgba(255,168,55,0.5) !important;',
        Fault: 'color: #F37B7B;border-color:#F37B7B;background-color: rgba(243,123,123,0.5) !important;'
      },
      status: {
        Warn: {
          show: true,
          icon: require('@/assets/image/monitoring/icon_alert02.png')
        },
        Fault: {
          show: true,
          icon: require('@/assets/image/monitoring/icon_alert01.png')
        },
        Error: {
          show: true,
          icon: require('@/assets/image/monitoring/icon_alert02.png')
        }
      }
    }
  },
  created: () => {
    // DOM이 만들어 지기 전 실행 되는 곳
    // Data를 사전에 준비할 경우 사용된다.

  },
  mounted: () => {
    // DOM에 해당 .vue가 들어가게 되면 실행 되는 곳
    // onload 상태와 동일하다. DOM 이후에 조작할 경우 이곳에서 수행

  },
  watch: {
    refresh(newValue) {
      if (this.show) {
        getMonitoringSiteInverter(this.info.siteId).then(res => {
          this.inverters = res
        })
      }
      this.refreshFlag++
    }
  },
  computed: {
    // 값이 자주 변경됨에 따라, 관련되어 데이터 혹은 view가 바뀌어야 할 경우 사용
    // method를 바로 연결하면 tic 단위로 계속 실행되기 때문에, 값이 변경할 때만 수행되고,
    // cache로 남는 computed를 활용하는 것이 성능에 좋음
    info() {
      return {
        pvpcsPac: this.site.PVPCS_Pac.toFixed(2),
        pvpcsDailyP: this.site.PVPCS_Daily_P.toFixed(2),
        dailytime: this.site.Daily_Time.toFixed(2),
        runStatus: this.site.run_status,
        communicationStatus: this.site.communicationStatus,
        siteId: this.site.SITE_ID,
        title: this.site.DESCRIPTION,
        pvpcsPacMax: this.site.totalCapacity * 1.1,
        pvpcsDailyPMax: this.site.totalCapacity * 8 * 1.1
      }
    },
    showStatus() {
      let obj = this.status[this.info.runStatus] // Run
      let obj2 = this.status[this.info.communicationStatus]
      let result = obj || obj2 || { show: false }
      return result
    }
  },
  methods: {
    // .vue 내부에서 사용되는 함수를 정의한다.
    // 이벤트에 따라 실행하거나, 내부적으로 사용되는 함수들을 정의한다.
    openDrawer() {
      if (!this.show) {
        getMonitoringSiteInverter(this.info.siteId).then(res => {
          this.inverters = res
          this.show = !this.show
        })
      } else {
        this.show = !this.show
      }
    },
    clickTitle() {
      this.$emit('clickTitle', this.info.siteId)
    },
    getInverterStatusImage(runStatus) {
      return runStatus === 'Run' ? this.inverterStatus.Run : runStatus === 'Pause' ? this.inverterStatus.Pause : this.inverterStatus.Fault
    }
  }
}
</script>

<style lang="less" scoped>
/* css 혹은 less로 스타일 정의하는 부분 */
/* 퍼블리셔 작업 영역 */

// lang="less"로 <style> 태그에 속성으로 넣어야 less를 사용할 수 있다.

.test-box {
  border: 1px solid lightgreen;
}

.site-card-time {
  color:#FFD754;
  font-weight: bold;
  font-size: 15px;
}
</style>
